"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import Image from "next/image";
import colors from "../../styles/colors";
import item1 from "../../public/item1.png";
import item2 from "../../public/item2.png";
import item3 from "../../public/item3.png";
import item4 from "../../public/item4.png";
import item5 from "../../public/item5.png";
import { useRouter } from "next/navigation";

export default function Category() {
  const router = useRouter()

  const items = [
    { item_img: item1, title: "On Grid Solar Panel", key: "68ba956f26b5d7bbd82a6d3e", subCategory: "ongrid" },
    { item_img: item2, title: "Off Grid Solar Panel", key: "68ba956f26b5d7bbd82a6d3e", subCategory: "offgrid" },
    { item_img: item3, title: "Solar Street Light", key: "68c124b9c908f5b359b3d519" },
    { item_img: item4, title: "Solar Pump", key: "68c11efac908f5b359b3d4f5" },
    { item_img: item5, title: "Solar Inverter", key: "68c12490c908f5b359b3d517" },
  ];

  return (
    <div className="w-full h-auto mt-10 flex justify-center items-center text-center">

      <div className="max-w-[90.3rem] xl:px-0 2xl:px-0 px-2 
             flex xl:justify-center 2xl:justify-center justify-start 
             xl:gap-[6.9rem] 2xl:gap-[6.9rem] md:gap-14 gap-5
             items-center text-center
             xl:overflow-x-hidden  2xl:overflow-x-hidden overflow-x-auto
             hide-scrollbar">
        {items.map((data, index) => {
          const href = data.subCategory
            ? `/products/filter-products?category=${data.key}&subCategory=${data.subCategory}`
            : `/products/filter-products?category=${data.key}`;

          return (
            <div
              key={index}
              className="flex flex-col md:gap-2 gap-4 items-center flex-shrink-0 cursor-pointer"
              onClick={() => router.push(href)}
            >
              <div className="md:w-[70px] max-w-[60px] h-[70px] md:h-[80px]">
                <Image
                  src={data.item_img}
                  alt={data.title}
                  width={63}
                  height={80}
                  className="object-cover"
                />
              </div>
             <span
  style={{ color: colors.text }}
  className="
text-sm max-w-[100px] md:max-w-[120px] lg:max-w-[150px] 
    text-gray-700 text-center
    break-words
      "
>
  {data.title}
</span>

         </div>
          );
        })}
      </div>
    </div>
  );
}
